import { WithAuth } from "../features/auth/HoC/withAuth";
import MainLayout from "../layouts/MainLayout/MainLayout";
import HomePage from "../pages/HomePage/HomePage";
import LoginPage from "../pages/LoginPage/LoginPage";
import NewAdminUserPage from "../pages/NewAdminUserPage/NewAdminUserPage";
import RoutesGenerator from "../utils/navigation/RoutesGenerator/RoutesGenerator";
import { QueryClient, QueryClientProvider } from "react-query";
import OrganizationListPage from "../pages/OrganizationPages/OrganizationListPage/OrganizationListPage";
import SingleOrganizationPage from "../pages/OrganizationPages/SingleOrganizationPage/SingleOrganizationPage";
import LandingPage from "../pages/LandingPage/LandingPage";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";
import { userRoles } from "../features/user/types/user.types";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import UserListPage from "../pages/UserPage/UserListPage/UserListPage";
import StationListPage from "../pages/StationPages/StationListPage/StationListPage";
import SingleStationPage from "../pages/StationPages/SingleStationPage/SingleStationPage";
import HardwareListPage from "../pages/HardwarePages/HardwareListPage/HardwareListPage";
import PaygoListPage from "../pages/PaygoPages/PaygoListPage/PaygoListPage";
import InvitListPage from "../pages/InvitPages/InvitListPage/InvitListPage";
import SingleUserPage from "../pages/UserPage/SingleUserPage/SingleUserPage";
import LoginAdminPage from "../pages/LoginAdminPage/LoginAdminPage";
import ClientListPage from "../pages/ClientPages/ClientListPage/ClientListPage";
import SingleClientPage from "../pages/ClientPages/SingleClientPage/SingleClientPage";
import SingleWalletPage from "../pages/WalletsPage/SingleWalletPages/SingleWalletPage";
import SingleClientExtendPage from "../pages/ClientPages/SingleClientExtendPage/SingleClientExtendPage";
import ConfidentialPolicyPage from "../pages/ConfidentialPolicyPage/ConfidentialPolicyPage";
import ChargingSessionListPage from "../pages/ChargingSessionPage/ChargingSessionListPage/ChargingSessionListPage";
import ResetUserPasswordPage from "../pages/UserPage/ResetUserPasswordPage/ResetUserPasswordPage";
import ResetPasswordRequestPage from "../pages/ResetPasswordRequestPage/ResetPasswordRequestPage";

/**
 * mainPageRoutes
 *
 * Route list of application
 */
export const mainPageRoutes = [
  {
    path: "/",
    name: "Home",
    main: () => <LandingPage />,
  },
  {
    path: "/login",
    name: "Login",
    main: () => <LoginPage />,
  },
  {
    path: "/confidential_policy",
    name: "Confidential Policy",
    main: () => <ConfidentialPolicyPage />,
  },
  {
    path: "/sup-admin/login",
    name: "Login",
    main: () => <LoginAdminPage />,
  },
  {
    path: "/sup-admin/*",
    name: "Home",
    main: () => <SuperAdminRoutes />,
  },
  {
    path: "/admin/new-account",
    name: "New Admin  Account",
    main: () => <NewAdminUserPage />,
  },
  {
    path: "/admin/*",
    name: "New Admin  Account",
    main: () => <AdminRoutes />,
  },

  {
    path: "/user/*",
    name: "UserRoutes",
    main: () => <AdminRoutes />,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    main: () => <ResetUserPasswordPage />,
  },

  {
    path: "/reset-password-request",
    name: "Reset Password Request",
    main: () => <ResetPasswordRequestPage />,
  },

  {
    path: "*",
    name: "Page not found",
    main: () => <NotFoundPage />,
  },
  {
    path: "/error-not-allowed",
    name: "Page non authorisée",
    main: () => (
      <ErrorPage
        title="Oops, vous n'avez pas été invité ici !"
        description="Vous n'êtes pas authorisée à accéder à cette page. Veuillez contacter votre administrateur."
        withLogOutBtn
      />
    ),
  },
  {
    path: "/error",
    name: "Erreur",
    main: () => (
      <ErrorPage
        title="Oops, une petite erreur technique !"
        description="Veuillez réessayer ulterieurement."
        withLogOutBtn
      />
    ),
  },
];

export default mainPageRoutes;

/**
 * AdminRoutes
 * @returns
 */
export const SuperAdminRoutes = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
  });

  const withAuthRoutes = [
    {
      path: "/",
      name: "Home",
      main: () => <HomePage />,
    },
    {
      path: "/stations",
      name: "Stations",
      main: () => <StationListPage />,
    },
    {
      path: "/stations/:stationId",
      name: "Single Station",
      main: () => <SingleStationPage />,
    },
    {
      path: "/organizations",
      name: "orgnisations",
      main: () => <OrganizationListPage />,
    },
    {
      path: "/users",
      name: "users",
      main: () => <UserListPage />,
    },
    {
      path: "/organizations/:organizationId",
      name: "Single Organization",
      main: () => <SingleOrganizationPage />,
    },
    {
      path: "/organizations/:organizationId/wallet/:walletId",
      name: "Single Organization Wallet",
      main: () => <SingleWalletPage />,
    },
    {
      path: "/hardwares",
      name: "Hardware",
      main: () => <HardwareListPage />,
    },
    {
      path: "/users/invitations",
      name: "Invitations",
      main: () => <InvitListPage />,
    },

    {
      path: "/users/:userOrgaId",
      name: "Single User",
      main: () => <SingleUserPage />,
    },

    {
      path: "/paygos",
      name: "Paygo",
      main: () => <PaygoListPage />,
    },
    {
      path: "*",
      name: "Page not found",
      main: () => <h1>404 - page introuvable</h1>,
    },
    {
      path: "/client-extends",
      name: "Clients",
      main: () => <ClientListPage />,
    },
    {
      path: "/client-extends/:userOrgaId",
      name: "Clients",
      main: () => <SingleClientExtendPage />,
    },
    {
      path: "/client-extends/:userOrgaId/wallets/:walletId",
      name: "Wallet",
      main: () => <SingleWalletPage />,
    },
    {
      path: "/charging-sessions",
      name: "Charging Sessions Liste",
      main: () => <ChargingSessionListPage />,
    },

    {
      path: "/charging-sessions/:chargingSessionId",
      name: "Charging Sessions",
      main: () => <ChargingSessionListPage />,
    },
  ];
  return (
    <QueryClientProvider client={queryClient}>
      <WithAuth userRolesGranted={[userRoles.SUPER_ADMIN]}>
        <MainLayout>
          <RoutesGenerator routesList={withAuthRoutes} />
        </MainLayout>
      </WithAuth>
    </QueryClientProvider>
  );
};

/**
 * AdminRoutes
 * @returns
 */
export const AdminRoutes = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
  });

  const withAuthRoutes = [
    {
      path: "/",
      name: "Home",
      main: () => <HomePage />,
    },
    {
      path: "/stations",
      name: "Stations",
      main: () => <StationListPage />,
    },
    {
      path: "/stations/:stationId",
      name: "Single Station",
      main: () => <SingleStationPage />,
    },
    {
      path: "/users",
      name: "users",
      main: () => <UserListPage />,
    },
    {
      path: "/users/:userOrgaId",
      name: "Single User",
      main: () => <SingleUserPage />,
    },
    {
      path: "/users/invitations",
      name: "Invitations",
      main: () => <InvitListPage />,
    },
    {
      path: "/organizations/:organizationId",
      name: "Single Organization",
      main: () => <SingleOrganizationPage />,
    },
    {
      path: "/organizations/:organizationId/wallet/:walletId",
      name: "Single Organization Wallet",
      main: () => <SingleWalletPage />,
    },
    {
      path: "/paygos",
      name: "Paygo",
      main: () => <PaygoListPage />,
    },
    {
      path: "/clients/:clientId",
      name: "Clients",
      main: () => <SingleClientPage />,
    },
    {
      path: "/clients/:clientId/wallets/:walletId",
      name: "Wallet",
      main: () => <SingleWalletPage />,
    },
    {
      path: "/client-extends/:userOrgaId",
      name: "Client extends",
      main: () => <SingleClientExtendPage />,
    },
    {
      path: "/charging-sessions",
      name: "Charging Sessions Liste",
      main: () => <ChargingSessionListPage />,
    },

    {
      path: "/charging-sessions/:chargingSessionId",
      name: "Charging Sessions",
      main: () => <ChargingSessionListPage />,
    },

    {
      path: "*",
      name: "Page not found",
      main: () => <h1>404 - page introuvable</h1>,
    },
  ];
  return (
    <QueryClientProvider client={queryClient}>
      <WithAuth userRolesGranted={[userRoles.ADMIN, userRoles.USER]}>
        <MainLayout>
          <RoutesGenerator routesList={withAuthRoutes} />
        </MainLayout>
      </WithAuth>
    </QueryClientProvider>
  );
};
